export default __webpack_public_path__ + "assets/images/b1fe7a4d995e1567247e58a16d1d3ce9.webp";